import AccessDeniedComponent from './AccessDeniedComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getClientFavicon } from '../../../actions/ui/init/initSelectors';

// Connect the STATE to the props fed into the component.
export const mapStateToProps = (state) => ({
  favicon: getClientFavicon(state)
});

// Connect ACTIONS to the props fed into the component.
export const mapDispatchToProps = (dispatch) =>
  bindActionCreators({}, dispatch);

// Create higher-order component which feeds in specified props.
const AccessDeniedContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccessDeniedComponent);

export default AccessDeniedContainer;



// WEBPACK FOOTER //
// ./src/components/pages/AccessDenied/AccessDeniedContainer.js